export default {
    overlaysActive: 0,
};
